import api from "./index";

// ========== 试剂管理 ==========

// 分页查询试剂列表
export function fetchReagentPage(params) {
    return api.post("/web/reagent/page", params);
}

// 根据ID查询试剂详情
export function getReagentById(id) {
    return api.get(`/web/reagent/${id}`);
}

// 根据名称模糊搜索试剂列表（用于自动补全下拉）
export function queryReagentByName(name) {
    return api.post("/web/reagent/page", { name, current: 1, pageSize: 50 });
}

// 新增试剂
export function createReagent(data) {
    return api.post("/web/reagent/add", data);
}

// 修改试剂
export function updateReagent(data) {
    return api.put("/web/reagent/update", data);
}

// 删除试剂
export function deleteReagent(id) {
    return api.delete(`/web/reagent/delete/${id}`);
}

// ========== 出库管理 ==========

// 分页查询出库记录
export function fetchReagentOutPage(params) {
    return api.post("/web/reagent/out/page", params);
}

// 新增出库记录
export function createReagentOut(data) {
    return api.post("/web/reagent/out/add", data);
}

// 删除出库记录
export function deleteReagentOut(id) {
    return api.delete(`/web/reagent/out/delete/${id}`);
}

// 撤销出库记录（恢复库存+配额）
export function revokeReagentOut(id) {
    return api.post(`/web/reagent/out/revoke/${id}`);
}
